<template>
  <div class="devOps_producerSpaceIndex" v-loading="loading">
    <el-row :gutter="10" style="margin-bottom:3px">
      <el-col :span="16" style="background: #fff;height:260px;">
        <div class="table-row">
        <div class="col-left">
          <div class="show-date">{{today_date}}</div>
          <div class="show-welcome">{{welcome}}</div>
          <div class="task-bottom">
          <div class="task-box">
            <div class="todo-count"><span>本周待处理</span>  <span style="font-weight: bold;color:#2e7fff;">{{notFinishedTask}}/{{allTask}}</span>&nbsp;&nbsp;<span>已完成</span></div> <span style="font-weight: bold;color:#2e7fff;">&nbsp;{{taskProgress}}%</span>
          </div>
            <div style="padding-right: 10px;">
            <el-progress :show-text="false" :percentage="taskProgress" color="#3785ff"></el-progress>
            </div>
          </div>
          <div  style="width: 100%;font-weight: bold"><span>职能：</span></div>
          <span>{{tasksCount.roleName}}</span>
          <div  style="width: 100%;"><span style="font-weight: bold">职能组织：</span><span style="color:#2e7fff;cursor: pointer;" @click="linkFrom('department')">{{tasksCount.dept_data}}</span></div>
          <div class="teamInfo">
            <div class="teamCount"><span style="font-weight: bold;">我的团队：</span><span  style="color:#2e7fff;font-weight: bold;cursor: pointer;" @click="linkFrom('team')">{{tasksCount.teamCount}}</span>
              <!--
              <div class="teamCount" style="margin-left: 12px;" @click="linkFrom('team')">{{tasksCount.teamCount}}</div>-->
            </div>
          </div>
        </div>
        <div class="col-right">
          <div class="pending-title">剩余工作总计</div>
          <el-row class="row_1">
            <div class="r r1">
              <span>开发任务</span>
              <p class="title-count" @click="linkFrom('dev')">{{tasksCount.devCount}}</p>
            </div>
            <div class="r r1">
              <span>测试任务</span>
              <p class="title-count" @click="linkFrom('test')">{{tasksCount.testCount}}</p>
            </div>
            <div class="r r1">
              <span>BUG</span>
              <p class="title-count" @click="linkFrom('bug')">{{tasksCount.bugCount}}</p>
            </div>
            <div class="r r1">
              <span>工单</span>
              <p class="title-count" @click="linkFrom('workOrder','workOrder')">{{tasksCount.workCount}}</p>
            </div>
          </el-row>
          <el-row class="row_1">
            <div class="r r1">
              <span>其他任务</span>
              <p class="title-count" @click="linkFrom('other')">{{tasksCount.otherTaskCount}}</p>
            </div>
            <div class="r r1">
              <span>项目</span>
              <p class="title-count" @click="linkFrom('project')">{{tasksCount.projectCount}}</p>
            </div>
            <div class="r r1">
              <span>需求</span>
              <p class="title-count" @click="linkFrom('demand',tasksCount.demand_list)">{{tasksCount.demandCount}}</p>
            </div>
            <div class="r r1">
              <span v-if="isOperation">待分配工单</span>
              <p v-if="isOperation" class="title-count" @click="linkFrom('workOrder','deal')">{{tasksCount.allWorkCount}}</p>
            </div>
          </el-row>
<!--          <div v-if="this.isDevloper || this.isTester" style="font-weight: bold;padding-left: 20px;">日进度提交</div>-->
<!--          <el-row class="row_1 report" style="height: 35px;margin-left: 51px;">-->
<!--            <div v-if="this.isDevloper" class="r r1" @click="getReportList('dev')">-->
<!--              <span class="el-icon-s-data">开发任务日进度提交</span>-->
<!--            </div>-->
<!--            <div v-if="this.isTester" class="r r1" @click="getReportList('test')">-->
<!--              <span class="el-icon-s-data">测试任务日进度提交</span>-->
<!--            </div>-->
<!--            <div class="r r1">-->
<!--            </div>-->
<!--          </el-row>-->
        </div>
        </div>
      </el-col>
      <el-col :span="8" >
        <el-card class="box-card" style="height:260px;padding: 0;">
          <div slot="header" class="clearfix">
            <span class="card-header">提醒</span>
          </div>
         <ul v-if="remindList.length > 0" class="infinite-list" v-infinite-scroll="load" style="overflow:auto;height: 170px;">
            <template v-for="(item,index) in remindList">
              <li v-if="item.tasktype === 'rd' || item.tasktype === 'rt'" :class="['infinite-list-item',item.priority]" @click="showDialogVisible(item.tasktype,item)">{{item.date}}</li>
              <li v-else :class="['infinite-list-item',item.priority]" @click="showDialogVisible(item.tasktype,item)">{{item.desc}}</li>
            </template>
          </ul>
          <el-empty v-else  :image-size="50" description="暂无内容"></el-empty>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-bottom:3px">
      <el-col :span="16" style="padding-left: 5px;padding-right: 0;">
        <el-card class="box-card" style="/*padding-right:10px ;*/height:320px">
          <div slot="header" class="clearfix">
            <span class="card-header">我的待处理</span>
          </div>
          <template v-if="isDevloper || isTester || isReviewer || isPm || isOperation">
          <el-tabs v-model="tabName" type="border-card" style="border: none;" @tab-click="handleClick" v-if="isDevloper || isTester || isReviewer || isPm || isOperation">
            <el-tab-pane label="工单" name='10' v-if="isOperation"    >
              <div slot="label">
                <div>待分配工单<span class="todo-num">（{{dynamicCount.undo_work_order}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="开发任务" name='1' v-if="isDevloper">
              <div slot="label">
                <div>开发任务<span class="todo-num">（{{dynamicCount.undo_dev}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="测试任务" name='2' v-if="isTester">
              <div slot="label">
                <div>测试任务<span class="todo-num">（{{dynamicCount.undo_test}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="其他任务" name='3' v-if="isOther">
              <div slot="label">
                <div>其他任务<span class="todo-num">（{{dynamicCount.undo_other}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="BUG" name='4' v-if="isDevloper || isTester">
              <div slot="label">
                <div>BUG<span class="todo-num">（{{dynamicCount.undo_bug}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="需求评审" name='5' v-if="isPm">
              <div slot="label">
                <div>需求评审<span class="todo-num">（{{dynamicCount.undo_xqps}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="技术评审" name='6' v-if="isReviewer">
              <div slot="label">
                <div>技术评审<span class="todo-num">（{{dynamicCount.undo_jsps}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="UAT" name='7' v-if="isPm">
              <div slot="label">
                <div>UAT<span class="todo-num">（{{dynamicCount.undo_uat}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="上线申请" name='8' v-if="isPm">
              <div slot="label">
                <div>上线申请<span class="todo-num">（{{dynamicCount.undo_fbsq}}）</span></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="线上验证" name='9' v-if="isPm">
              <div slot="label">
                <div>线上验证<span class="todo-num">（{{dynamicCount.undo_xsyz}}）</span></div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <devTaskIndex :tableData="tableData" v-if="tabName === '1'" @changeTask="changeTask"></devTaskIndex>
          <testTaskIndex :tableData="tableData" v-if="tabName === '2'" @changeTask="changeTask"></testTaskIndex>
          <otherIndex :tableData="tableData" v-if="tabName === '3'" @changeTask="changeTask"></otherIndex>
          <bugIndex :tableData="tableData" v-if="tabName === '4'" @changeTask="changeTask"></bugIndex>
          <reviewDemandIndex :tableData="tableData" v-if="tabName === '5'" @changeTask="changeTask"></reviewDemandIndex>
          <reviewDevIndex :tableData="tableData" v-if="tabName === '6'" @changeTask="changeTask"></reviewDevIndex>
          <uatIndex :tableData="tableData" v-if="tabName === '7'" @changeTask="changeTask"></uatIndex>
          <onlineIndex :tableData="tableData" v-if="tabName === '8'" @changeTask="changeTask"></onlineIndex>
          <verifyIndex :tableData="tableData" v-if="tabName === '9'" @changeTask="changeTask"></verifyIndex>
          <workOrderIndex :tableData="tableData" v-if="tabName === '10'" @changeTask="changeTask"></workOrderIndex>
          </template>
          <template v-else>
            <el-empty style="height: 264px;" :image-size="50" description="暂无内容"></el-empty>
          </template>
        </el-card>
      </el-col>
      <el-col :span="8" >
        <el-card class="box-card" style="height:320px;">
          <div slot="header" class="clearfix">
            <span class="card-header">最新动态</span>
          </div>
          <div class="news-time" v-if="showTime.length > 0">
            <el-timeline>
             <template v-for="item in showTime">
              <el-timeline-item :timestamp="item" placement="top">
                <div class="list-time-item" v-for="(item2,index2) in dynamic[item]">
                  <div>{{item2.adjusted_time}} {{item2.user_name_zh}}({{item2.user_name}})　{{item2.stage_desc}}　　<span>【{{item2.id}}】{{item2.name}}</span></div>
                </div>
              </el-timeline-item>
             </template>
            </el-timeline>
          </div>
          <!--
          <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto;height: 245px;"  v-if="dynamic.length > 0">
            <li class="infinite-list-item news" v-for="item in dynamic">{{item.adjusted_time}} {{item.user_name_zh}}（{{item.user_name}}）({{item.id}}){{item.name}}　{{item.stage_desc}}</li>
          </ul>
          -->
         <el-empty v-else  :image-size="50" description="暂无内容"></el-empty>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-bottom:3px">
      <el-col :span="16" style="padding-left: 0;padding-right: 0;">
        <el-card class="box-card" style="padding-right:10px ;height:100%">
          <div slot="header" class="clearfix">
            <span class="card-header">最近参与需求</span>
            <span class="card-more" @click="lookMore('demand')">更多<i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="take-part-project">
            <el-row :gutter="12">
              <template v-if="demandList.length > 0">
              <el-col :span="8"  class="project-list" v-for="(item,index) in demandList" :key="index" style="cursor: pointer;">
                <el-card shadow="hover" @click.native="lookMore('demand',item.demandId)">
                  <div class="demand-detail">
                  <p class="title"> 【{{item.demandId}}】{{item.demandName}} </p>
                  <p class="sys"><span class="ctitle">项目体系：</span><span>{{item.projectsystem}}</span></p>
                  <p class="project"><span class="ctitle">项目：</span><span>【{{item.projectId}}】 {{item.projectName}}</span></p>
                  <p class="status"><span class="ctitle">状态：</span><span>{{item.demandStatus}}</span></p>
                  <p class="project"><span class="ctitle">产品：</span><span>{{item.pm.nameZh}}({{item.pm.nameEn}})</span></p>
                  <p class="project"><span class="ctitle">技术负责人：</span><span>{{item.reviewer.nameZh}}({{item.reviewer.nameEn}})</span></p>
                  </div>
                </el-card>
              </el-col>
              </template>
              <el-empty v-else  :image-size="50" description="暂无内容"></el-empty>
            </el-row>
          </div>
        </el-card>
        <el-card class="box-card" style="padding-right:10px ;height:260px">
          <div slot="header" class="clearfix">
            <span class="card-header">最近参与项目</span>
            <span class="card-more" @click="lookMore('project')">更多<i class="el-icon-arrow-right"></i></span>
          </div>
          <div class="take-part-project">
            <el-row :gutter="12">
              <template v-if="projectList.length > 0">
              <el-col :span="8" class="project-list" v-for="(item,index) in projectList" :key="index" style="cursor: pointer;">
                <el-card shadow="hover" @click.native="lookMore('project',item.projectId)">
                  <div class="project-detail" style="line-height: 30px;">
                    <p class="title"> 【{{item.projectId}}】{{item.projectName}} </p>
                    <p class="sys"><span class="ctitle">项目体系：</span><span>{{item.projectsystem}}</span></p>
                    <p class="status"><span class="ctitle">状态：</span><span>{{item.projectstatus}}</span></p>
                    <p class="project"><span class="ctitle">项目负责人：</span><span>{{item.owner.nameZh}}({{item.owner.nameEn}})</span></p>
                  </div>
                </el-card>
              </el-col>
              </template>
              <el-empty v-else  :image-size="50" description="暂无内容"></el-empty>
            </el-row>

          </div>
        </el-card>
      </el-col>
      <el-col :span="8" >
        <el-card class="box-card" style="height:480px">
          <div slot="header" class="clearfix">
            <span class="card-header">我的贡献</span>
          </div>
          <div>
            <el-row class="row_2">
              <div class="r r1">
                <span>创建的项目</span>
                <p @click="linkFromTo('project',1)">{{contribute.createProject}}</p>
              </div>
              <div class="r r1">
                <span>创建的需求</span>
                <p @click="linkFromTo('demand',2)">{{contribute.createDemand}}</p>
              </div>
              <div class="r r1">
                <span>评审的需求</span>
                <p @click="linkFromTo('demand',3)">{{contribute.reviewDemand}}</p>
              </div>
            </el-row>
            <el-row class="row_2" style="margin-bottom:20px;">
              <div class="r r1">
                <span>创建的开发任务</span>
                <p @click="linkFromTo('task',4)">{{contribute.createDevTask}}</p>
              </div>
              <div class="r r1">
                <span>创建的测试任务</span>
                <p @click="linkFromTo('test',5)">{{contribute.createTestTask}}</p>
              </div>
              <div class="r r1">
                <span>完成的开发任务</span>
                <p @click="linkFromTo('task',6)">{{contribute.createFinishDev}}</p>
              </div>
            </el-row>
            <el-row class="row_2">
              <div class="r r1">
                <span>完成的测试任务</span>
                <p @click="linkFromTo('test',7)">{{contribute.createFinishTest}}</p>
              </div>
              <div class="r r1">
                <span>解决的BUG</span>
                <p @click="linkFromTo('bug',8)">{{contribute.finishBug}}</p>
              </div>
              <div class="r r1">
                <span>提出的BUG</span>
                <p @click="linkFromTo('bug',9)">{{contribute.putBug}}</p>
              </div>
            </el-row>
            <el-row class="row_2">
              <div class="r r1">
                <span>创建的其他任务</span>
                <p @click="linkFromTo('other',10)">{{contribute.createOtherTask}}</p>
              </div>
              <div class="r r1">
                <span>完成的其他任务</span>
                <p @click="linkFromTo('other',11)">{{contribute.finishOtherTask}}</p>
              </div>
              <div class="r r1">
                <span>创建的工单</span>
                <p @click="linkFromTo('workOrder',12)">{{contribute.createWorkOrder}}</p>
              </div>
            </el-row>
            <el-row class="row_2">
              <div class="r r1">
                <span>完成的工单</span>
                <p @click="linkFromTo('workOrder',13)">{{contribute.finishWorkOrder}}</p>
              </div>
              <div class="r r1">
              </div>
              <div class="r r1">
              </div>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <Demand v-if="dialogVisible.demand" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.demand'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"/>
    <Task v-if="dialogVisible.task" :back="back" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
          :formInfo="checkedInfo"/>
    <TestTask v-if="dialogVisible.addTest" :dialogVisible='dialogVisible.addTest' :hideDialogVisible="hideDialogVisible"
              :formInfo="checkedInfo"/>
    <CreateBug v-if="dialogVisible.createBug" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.createBug'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></CreateBug>
    <CreateOther v-if="dialogVisible.createOther" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.createOther'
                 :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></CreateOther>
    <ReportList v-if="dialogVisible.report" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.report'
                :hideDialogVisible="hideDialogVisible" @change="change" :reportData="reportData"  :newTitle="newTitle" :type="type"/>
  </div>
</template>
<script>
import {
  getDevOpsSpaceDealWorkOrderApi,
  getDevOpsSpaceDynamicCountApi, getDevOpsSpaceIndexAllDataApi,
  getDevOpsSpaceIndexContributeApi,
  getDevOpsSpaceIndexCountApi,
  getDevOpsSpaceIndexdDynamicApi,
  getDevOpsSpaceIndexDemandListApi,
  getDevOpsSpaceIndexProgressApi,
  getDevOpsSpaceIndexProjectListApi,
  getDevOpsSpaceIndexRemindApi,
  getDevOpsSpaceIndexUndoneApi,
  getDevOpsSpaceReportTaskListApi,
  getDevOpsSpaceReportTestTaskListApi
} from "@/server/tops/devOps";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
import devTaskIndex from '@/views/tops/devOps/index/components/devTask.vue';
import testTaskIndex from '@/views/tops/devOps/index/components/testTask.vue';
import otherIndex from '@/views/tops/devOps/index/components/other.vue';
import bugIndex from '@/views/tops/devOps/index/components/bug.vue';
import uatIndex from '@/views/tops/devOps/index/components/uat.vue';
import verifyIndex from '@/views/tops/devOps/index/components/verify.vue';
import onlineIndex from '@/views/tops/devOps/index/components/online.vue';
import reviewDemandIndex from '@/views/tops/devOps/index/components/reviewDemand.vue';
import reviewDevIndex from '@/views/tops/devOps/index/components/reviewDev.vue';
import workOrderIndex from '@/views/tops/devOps/index/components/workOrder.vue';
import ReportList from "@/views/tops/devOps/producerSpace/components/report/list.vue";
import { Demand, Task } from '@/views/tops/devOps/producerSpace/components';
import TestTask from '@/views/tops/devOps/producerSpace/components/testTask';
import CreateBug from '@/views/tops/devOps/producerSpace/components/bug/create.vue';
import CreateOther from '@/views/tops/devOps/producerSpace/components/other/create.vue';
import { mapState, mapMutations } from 'vuex';
export default {
  components: {
    ReportList,
    Demand,
    Task,
    TestTask,
    CreateBug,
    devTaskIndex,testTaskIndex,otherIndex,bugIndex,uatIndex,verifyIndex,onlineIndex,reviewDemandIndex,reviewDevIndex,CreateOther,workOrderIndex},
  data() {
    return {
      realProgress: 50,
      tableData:[
      ],
      tasksCount:{
        roleName:'',
        demand_list:'',
        bugList:'',
        otherTaskList:'',
      },
      remindList:[],
      projectList:[],
      demandList:[],
      contribute:{},
      today_date: this.getNowDate(),
      allUser:[],
      welcome:'',
      progressData:{},
      notFinishedTask:0,
      allTask: 0,
      taskProgress: 0,
      tabName:'',
      dynamic:[],
      showTime:[],
      reportLoading: false,
      reportData: [],
      dialogVisible: {
        demand: false,
        task: false,
        addTest: false,
        report: false,
        createBug: false,
        createOther: false
      },
      newTitle:'开发任务日报',
      type:1,
      demandids: '',
      projectids: '',
      bugids: '',
      otherids:'',
      loading: false,
      dynamicCount:{
        undo_dev:0,
        undo_test:0,
        undo_other:0,
        undo_bug:0,
        undo_xqps:0,
        undo_jsps:0,
        undo_uat:0,
        undo_fbsq:0,
        undo_xsyz:0,
        undo_work_order:0,
      },
    }
  },
  async mounted() {
    this.loading = true;
    await this.init(true);
    this.loading = false;


  },
  computed: {
    ...mapState(
        {
          userInfo: (state) => state.devOps.userInfo,
        }
    ),
    // 判断是否是测试
    isTester() {
      return this.tasksCount.roleName.includes('测试人员');
    },
    // 判断是否是开发
    isDevloper() {
      return this.tasksCount.roleName.includes('开发人员');
    },
    // 判断是否是技术负责人
    isReviewer() {
      return this.tasksCount.roleName.includes('技术负责人');
    },
    // 判断是否是产品
    isPm() {
      return this.tasksCount.roleName.includes('产品经理');
    },
    isOther(){
      if(this.tasksCount.roleName){
        return true;
      }
      return false;
    },
    //判断是否是运维
    isOperation() {
      return this.tasksCount.roleName.includes('运维');
    },
  },
  async created() {
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList', {userType: ''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList', {type: ''})
    //工单配置
    await this.$store.dispatch('getDevopsWorkOrderConfig')


  },
  methods:{
    async init(f = '') {
      await this.getWelcomeMsg();
      await this.getDevOpsSpaceIndexAllData();
      if(f){
        if(this.isReviewer) this.tabName = '6';
        if(this.isPm) this.tabName = '5';
        if(this.isOther) this.tabName = '3';
        if(this.isTester) this.tabName = '2';
        if(this.isDevloper) this.tabName = '1';
        if(this.isOperation) this.tabName = '10';
      }
      await this.getDevOpsSpaceIndexUndone();
    },
    async getDevOpsSpaceIndexCount() {
      await getDevOpsSpaceIndexCountApi().then((res) => {
         if(res.data){
           this.tasksCount = res.data[0];
         }
      })
    },
    async getDevOpsSpaceIndexRemind() {
      await getDevOpsSpaceIndexRemindApi().then((res) => {
        if (res.data) {
          this.remindList = res.data;
        }
      })
    },
    async getDevOpsSpaceIndexProjectList() {
      await getDevOpsSpaceIndexProjectListApi().then((res) => {
        if (res.data) {
          this.projectList = res.data;
          this.projectids = res.data_ids.toString();
        }
      })
    },
    async getDevOpsSpaceIndexDemandList() {
      await getDevOpsSpaceIndexDemandListApi().then((res) => {
        if (res.data) {
          this.demandList = res.data;
          this.demandids = res.data_ids.toString();
        }
      })
    },
    async getDevOpsSpaceIndexContribute() {
      await getDevOpsSpaceIndexContributeApi().then((res) => {
        if (res.data) {
          this.contribute = res.data;
        }
      })
    },
    async getDevOpsSpaceIndexProgress() {
      await getDevOpsSpaceIndexProgressApi().then((res) => {
        if (res.data) {
          if(res.data[0]){
            this.notFinishedTask =  res.data[0];
          }
          if(res.data[1]){
            this.allTask =  res.data[1];
          }
          if(res.data[2]){
            this.taskProgress =  res.data[2];
          }
        }
      })
    },
    async getDevOpsSpaceIndexdDynamic() {
      await getDevOpsSpaceIndexdDynamicApi().then((res) => {
        if (res.data) {
          let timeArr = [];
          res.data.forEach((item)=>{
            if(!timeArr.includes(item.adjusted_date)){
              timeArr.push(item.adjusted_date);
            }
          })
          this.showTime = timeArr.sort().reverse();
          const arr = res.data.reduce((acc, curr) => {
            const adjusted_date = curr.adjusted_date;
            if (!acc[adjusted_date]) {
              acc[adjusted_date] = [];
            }
            acc[adjusted_date].push(curr);
            return acc;
          }, []);
/*
          let ee= arr.sort();
          console.log(ee);*/
          this.dynamic  = arr;
        }
      })
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;font-size:12px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    lookMore(type,id = ''){
      let url = '';
      if(type === 'project'){
         url = `${window.location.origin}/Home/devOpsProjectSpace/project`;
        if(id) url = url + '?proId='+id;
        if(!id && this.projectids) url = url + '?ids='+this.projectids;
      }
      if(type === 'demand'){
        url = `${window.location.origin}/Home/devOpsDemandSpace/demand`;

        if(id) url = url + '?pid='+id;
        if(!id && this.demandids) url = url + '?ids='+ this.demandids;
      }
      window.parent.location.href = url;
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "年" + cmonth + "月" + cday + "日";
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
            arr[item.id] = item.user_name_zh;
        });
      }
      this.allUser = arr;
    },
    async getWelcomeMsg() {
      if (this.userInfo) {
        this.welcome = this.userInfo.user_name_zh + '，' + this.timeOfDay();
      } else {
        this.welcome = this.timeOfDay();
      }
    },
    timeOfDay() {
      const currentHour = new Date().getHours(); // 获取当前小时数
      if (currentHour >= 0 && currentHour <= 12) {
        return "上午好！";
      } else if (currentHour > 12 && currentHour < 18) {
        return "下午好！";
      } else if (currentHour >= 18 && currentHour <= 24) {
        return "晚上好！";
      } else {
        return "您好！";
      }
    },
    toJump(item){
      let url = '';
      let taksId = '';
      if(item.taksId){
        taksId = item.taksId;
      }
      //开发任务
      if(item.tasktype === 'd'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsTaskSpace?tid=${taksId}`;
      }
      //测试任务
      if(item.tasktype === 't'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsTaskSpace?testId=${taksId}`;
      }
      //其他任务
      if(item.tasktype === 'o'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsTaskSpace?tid=${taksId}`;
      }
      //缺陷管理
      if(item.tasktype === 'b'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsTaskSpace?bid =${taksId}`;
      }
      //需求
      if(item.tasktype === 'n'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsDemandSpace?pid =${taksId}`;
      }
      //开发日报
      if(item.tasktype === 'rd'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsTaskSpace`;
      }
      //测试日报
      if(item.tasktype === 'rt'){
        url = `${window.location.origin}/devops/space/producer?route=devOpsTaskSpace`;
      }
      window.parent.location.href = url;
    },
    handleClick(tab){
      this.getDevOpsSpaceIndexUndone();
    },
    async getDevOpsSpaceIndexUndone() {
      this.tableData = [];
      const res = this.tabName !=10 ? await getDevOpsSpaceIndexUndoneApi({type: this.tabName}):await getDevOpsSpaceDealWorkOrderApi({pageNo:1,pageSize:99999999999});
      if(res.data){
        this.tableData = res.data;
      }
    },
    linkFrom(type,demand_list = ''){
      let url = '';
      if(type === 'team'){
        if(!this.tasksCount.team_data){
          return false;
        }
        let teamId = this.tasksCount.team_data;
        url = `${window.location.origin}/Home/devOpsReporterSpace/report?teamId=${teamId}`;
      }
      if(type === 'department'){
        if(!this.tasksCount.dept_data){
          return false;
        }
        let department = this.tasksCount.dept_data;
        url = `${window.location.origin}/Home/devOpsReporterSpace/report?department=${department}`;
      }
      if(type === 'dev'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/devTask?nd=1`;
      }
      if(type === 'test'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/testTask?nd=1`;
      }
      if(type === 'bug'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/bugTask`;
        if(this.bugids) url = url + '?ids='+this.bugids;
      }
      if(type === 'other'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/otherTask`;
        if(this.otherids) url = url + '?ids='+this.otherids;
      }
      if(type === 'project'){
        url = `${window.location.origin}/Home/devOpsProjectSpace/project`;
      }
      if(type === 'demand'){
        url = `${window.location.origin}/Home/devOpsDemandSpace/demand`;
        if(demand_list){
          url = `${url}?ids=${demand_list}`;
        }
      }
      if(type === 'workOrder'){
        url = `${window.location.origin}/Home/devOpsWorkOrder/${demand_list}`;
      }
      window.parent.location.href = url;
     // window.open(url);
    },
    linkFromTo(type,ns){
      let url = '';
      if(type === 'task'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/devTask?ns=${ns}`;
      }
      if(type === 'test'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/testTask?ns=${ns}`;
      }
      if(type === 'bug'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/bugTask?ns=${ns}`;
      }
      if(type === 'other'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/otherTask?ns=${ns}`;
      }
      if(type === 'project'){
        url = `${window.location.origin}/Home/devOpsProjectSpace/project?ns=${ns}`;
      }
      if(type === 'demand'){
        url = `${window.location.origin}/Home/devOpsDemandSpace/demand?ns=${ns}`;
      }
      if(type === 'workOrder'){
        if(ns === 12) url = `${window.location.origin}/Home/devOpsWorkOrder/my?ns=${ns}`;
        if(ns === 13) url = `${window.location.origin}/Home/devOpsWorkOrder/workOrder?ns=${ns}`;
      }
      if(url){
        window.parent.location.href = url;
      }
    },
    async changeTask(){
      await this.init();
    },
    async getReportList(type){
      if(type === 'dev'){
        this.newTitle = '开发任务日报';
        this.type = 1;
      }
      if(type === 'test'){
        this.newTitle = '测试任务日报';
        this.type = 2;
      }
      this.reportLoading = true;
      let  params = {workDate:this.getDate()};
      try{
        const ret =  type === 'dev' ? await getDevOpsSpaceReportTaskListApi(params) : await getDevOpsSpaceReportTestTaskListApi(params);
        if(ret.status === 'success'){
          this.reportData = ret.data;
          this.dialogVisible['report'] = true;
        }
        this.reportLoading = false;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
        this.reportLoading = false;
      } finally {
        this.reportLoading = false;
      }
    },
    async change(date){
      let  params = {workDate:date};
      const ret =  this.type == '1' ? await getDevOpsSpaceReportTaskListApi(params) : await getDevOpsSpaceReportTestTaskListApi(params);
        if(ret.status === 'success'){
          this.reportData = ret.data;
        }
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 弹出模板
    async showDialogVisible(type, row , back = '') {
      if(type === 'rd'){
         this.getReportList('dev');
        return ;
      }
      if(type === 'rt'){
       this.getReportList('test');
        return ;
      }
      let showType = '';
      let newRow = {...row};
      if(type === 't'){
        newRow = {...row,taskInfo:{id: row.taksId,taskName: row.taksName},id:row.taksId};
        showType = 'addTest';
      }
      if(type === 'd'){
        newRow = {taskId:row.taksId}
        showType = 'task';
      }
      if(type === 'b'){
        newRow = {name : row.taksName, id: row.taksId}
        showType = 'createBug';
      }
      if(type === 'n'){
        newRow = {name : row.taksName, id: row.taksId}
        showType = 'demand';
      }
      if(type === 'o'){
        newRow = {name : row.taksName, id: row.taksId}
        showType = 'createOther';
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[showType] = true;
      this.back = back;

    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '') {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      this.init();
    },
    async getDevOpsSpaceDynamicCount() {
      await getDevOpsSpaceDynamicCountApi().then((res) => {
          if(res.status === 'success'){
            this.dynamicCount = res.data;
          }
      })
    },
    async getDevOpsSpaceIndexAllData() {
      await getDevOpsSpaceIndexAllDataApi().then((res) => {
        if(res.data[0]){
          this.tasksCount = res.data[0]['list_home_count'];
          this.bugids =  this.tasksCount.bugList;
          this.otherids = this.tasksCount.otherTaskList;
        }
        if (res.data[1]) {
          if(res.data[1]['list_all_count']){
            this.notFinishedTask =  res.data[1]['list_all_count'][0];
            this.allTask =  res.data[1]['list_all_count'][1];
            this.taskProgress =  res.data[1]['list_all_count'][2];
          }
        }
        // 最近参与项目 projectList
        if(res.data[2]){
          this.projectList = res.data[2]['next_project_sql_data'];
          this.projectids = res.data[2]['data_projects_ids'].toString();
        }
        //最近参与需求 demandList
        if(res.data[3]){
          this.demandList = res.data[3]['next_demand_data'];
          this.demandids = res.data[3]['data_demand_ids'].toString();
        }
        //我的贡献 contribute
        if(res.data[4]){
          this.contribute = res.data[4]['cort_data'];
        }
        //我的待处理数字
        if(res.data[5]){
          this.dynamicCount = res.data[5]['undo_data'];
        }
        //提醒
        if(res.data[6]){
          this.remindList = res.data[6]['remind_data'];
        }
        //最新动态
        if(res.data[7]){
          this.getMergeData(res.data[7]['dy_data']);
        }
      })
    },
    getMergeData(data){
      if (data) {
        let timeArr = [];
        data.forEach((item)=>{
          if(!timeArr.includes(item.adjusted_date)){
            timeArr.push(item.adjusted_date);
          }
        })
        this.showTime = timeArr.sort().reverse();
        const arr = data.reduce((acc, curr) => {
          const adjusted_date = curr.adjusted_date;
          if (!acc[adjusted_date]) {
            acc[adjusted_date] = [];
          }
          acc[adjusted_date].push(curr);
          return acc;
        }, []);
        this.dynamic  = arr;
      }
    },
  },
}
</script>
<style lang="scss">
.devOps_producerSpaceIndex {
  background-color: #f4f5f8;
  font-size: 14px;
  //padding: 0 20px;
  height: 90vh;
  overflow-x: hidden;
  overflow-y: scroll;
  //.item {
  //  display: flex;
  //  justify-content: flex-start;
  //  position: relative;
  //  .progress-item{
  //    position:absolute;
  //    width:80%;
  //  }
  //}
  .row_1 {
    background-color: #fff;
    display: flex;
    flex-direction: row;
    height: 62px;
    margin-top: 4px;
    .r {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .row_2 {
    background-color: #fff;
    display: flex;
    flex-direction: row;
    height: 70px;
    margin-top: 10px;
    .r {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    p{
      font-weight: bold;
      color:#2e7fff;
      cursor: pointer;
    }
  }

  .take-part-project{
    font-size: 12px;
  }
  .take-part-project .title{
    font-weight: bold;
    font-size: 12px;
    color:#2e7fff;
  }
  .take-part-project .ctitle{
    font-weight: bold;
  }
  .table-row{
    display: table;
    width: 100%;
    padding-left: 10px;
  }
  .col-left{
    line-height: 26px;
    width: 25%;
    display: table-cell;
    float: none;
    vertical-align: top;
  }
  .col-left .show-date{
    font-size: 12px;
    color: #838a9d;
  }
  .task-box{
    display: flex;
  }
  .show-welcome{
    font-weight: bold;
  }
  .col-right {
    border-left: 1px solid #e5e8ec;
    display: table-cell;
    float: none;
    vertical-align: top;
    width: 100%;
    padding-right: 5px;
  }
  .title-count{
    font-weight: bold;
    font-size: 18px;
    color: #2e7fff;
    cursor: pointer;
  }
  .el-card__body{
    padding: 0;
  }
  .box-card li{
    list-style-type:none;
    line-height: 24px;
    color:#2e7fff;
    cursor: pointer;
    font-size: 13px;
  }
  .project-detail{
    padding-left: 10px;
  }
  .demand-detail{
    padding-left: 10px;
  }
  .pending-title{
    line-height: 50px;
    height: 50px;
    padding-left: 15px;
    font-weight: bold;
  }
  .pending-box{
    background: #fff;
  }
  .card-header{
    font-weight: bold;
  }
  .el-tabs__nav-next, .el-tabs__nav-prev {
    line-height: 30px;
  }
  .el-tabs__item {
    width:120px;
    text-align: center;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 0;
    padding-top: 0;
    font-size: 12px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;

  }
  .el-tabs__content {
    padding: 5px;
  }
  .teamInfo{
   // margin-top: 10px;
  }
  .teamCount{
    //line-height: 23px;
    //width: 60px;
    //text-align: center;
  }
  .teamCount p{
    //margin-top: 0;
    //padding-top: 0;
  }
  .teamCount .teamCount{
    font-weight: bold;
    color: #2e7fff;
    cursor: pointer;
  }
  .card-more{
    float: right;
    font-size: 12px;
    cursor: pointer;
  }
  .project-list{
    padding: 10px 0px 10px 12px !important;
  }
  .report span{
    color: #2e7fff;
    cursor: pointer;
  }
  .red{
    color: #f56c6c !important;
  }
  .yellow{
    color: #e6a23c !important;
  }
}

.devOps_producerSpaceIndex::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.devOps_producerSpaceIndex::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.devOps_producerSpaceIndex::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.devOps_producerSpaceIndex .table_text_click_new {
  text-decoration: none;
  color: #409EFF;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.infinite-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.infinite-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.infinite-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
.news-time{
  padding: 15px 5px 15px 0;
  height: 226px;
  overflow:auto;
  //overflow-y: scroll;
  //overflow-x: hidden;
}

.news-time::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.news-time::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.news-time::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.devOps_producerSpaceIndex .el-timeline-item__content{
  line-height: 24px;
  font-size: 12px;
  color:#2e7fff;
}
.devOps_producerSpaceIndex .list-time-item{
  margin-bottom: 5px;
}

</style>
